import { render } from "./ModalBsWrapper.vue?vue&type=template&id=1957f1a8"
import script from "./ModalBsWrapper.vue?vue&type=script&lang=js"
export * from "./ModalBsWrapper.vue?vue&type=script&lang=js"

import "./ModalBsWrapper.vue?vue&type=style&index=0&id=1957f1a8&lang=scss"
import "./ModalBsWrapper.vue?vue&type=style&index=1&id=1957f1a8&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__